exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pagnationContainer\n{\n    position: relative;\n    height: 4vh;\n    padding-bottom: 3%;\n    -ms-flex-line-pack: center;\n        align-content: center;\n}\n\n.pagnationPreNextBox\n{\n    height: 100%;\n    width: 8%;\n    text-align: center;\n    float: left;\n    margin-right: 1%;\n    cursor: pointer;\n    background-color: rgb(50,50,50);\n    color: rgb(255,255,255);\n}\n\n.pagnationNumberBox\n{\n    height: 100%;\n    width: 3%;\n    text-align: center;\n    float: left;\n    margin-right: 1%;\n    cursor: pointer;\n    background-color: rgb(50,50,50);\n    color: rgb(255,255,255);\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ppeters/filmCritClient/src/app/components/pagnation/pagnation.component.css
// module id = ../../../../../src/app/components/pagnation/pagnation.component.css
// module chunks = main